import { CreateNS } from '../lib/createAPIBuilder';

export const installAPIConsent = (namespace: CreateNS) => {
    namespace('consent')(({ func, prop, deps }) => {
        func('getUserConsent', deps.getUserConsent);
        func('identifierForAdvertising', deps.getAdvertisingDeviceId);
        prop(
            'oneTrustConsentGroups',
            // @ts-expect-error deprecated
            deps.getOneTrustConsentGroups,
            {
                replacedWith: 'window.dazn.consent.getUserConsent',
            },
        );
        func('resetCookieScripts', deps.resetCookieScripts);
    });
};
